import { render, staticRenderFns } from "./PwaInstallBanner.vue?vue&type=template&id=384bdbb3&scoped=true"
import script from "./PwaInstallBanner.vue?vue&type=script&lang=js"
export * from "./PwaInstallBanner.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallBanner.vue?vue&type=style&index=0&id=384bdbb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bdbb3",
  null
  
)

export default component.exports